import { html } from "lit-element";
import { tagsLabels } from "../../../../styles/icons";
import { DrawTagsAndLabelsModule } from "./tags-labels-module";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { DrawSquaresModule } from "./squares-module.js";
import { DrawDecoHor1Module } from "./deco-hor-1-module";
import { DrawDecoHor2Module } from "./deco-hor-2-module";
import { DrawDecoVer1Module } from "./deco-ver-1-module";
import { DrawDecoVer2Module } from "./deco-ver-2-module";
import { DrawSdvHor1Module } from "./sdv-hor-1-module";
import { DrawSdvHor2Module } from "./sdv-hor-2-module";
import { DrawVdsHor1Module } from "./vds-hor-1-module";
import { DrawVdsHor2Module } from "./vds-hor-2-module";
import { DrawSluisHor1Module } from "./sluis-hor-1-module";
import { DrawSluisHor2Module } from "./sluis-hor-2-module";
import { DrawSluisHor3Module } from "./sluis-hor-3-module";
import { DrawSluisHor4Module } from "./sluis-hor-4-module";
import { DrawSluisVer1Module } from "./sluis-ver-1-module";
import { DrawSluisVer2Module } from "./sluis-ver-2-module";
import { DrawSluisVer3Module } from "./sluis-ver-3-module";
import { DrawSluisVer4Module } from "./sluis-ver-4-module";
import { DrawBobcatModule } from "./bobcat-module";
import { DrawKraanModule } from "./kraan-module";
import { DrawAanhangerModule } from "./aanhanger-module";
import { DrawVerreikerModule } from "./verreiker-module";
import { DrawPickupModule } from "./pickup-module";
import { DrawOdmModule } from "./odm-module";
import { DrawKeukenblokMagentaModule } from "./keukenblok-magenta-module";
import { DrawKeukenblokGreenModule } from "./keukenblok-green-module";
import { DrawKeukenblokRedModule } from "./keukenblok-red-module";
import { DrawCvBlueModule } from "./cv-blue-module";
import { DrawCvWhiteModule } from "./cv-white-module";
import { DrawRadiatorGreenModule } from "./radiator-green-module";
import { DrawRadiatorWhiteModule } from "./radiator-white-module";
import { DrawRadiatorBlueModule } from "./radiator-blue-module";
import { DrawContainerModule } from "./container-module";
import { DrawBigBagModule } from "./big-bag-module";
import { DrawPuinModule } from "./puin-module.js";
import { DrawBoomModule } from "./boom-module.js";
import { DrawBegroeiingModule } from "./begroeiing-module.js";
import { DrawBlueModule } from "./blue-module.js";
import { DrawSamplePumpModule } from "../samples-pumps/sample-pump-module.js";
import { SecondaryToolbarSeparator } from "../../ModuleBase/SecondaryToolbarSeparator";
import { DrawHoogwerkerModule } from "./hoogwerker-module";
import { DrawDvHor2Module } from "./dv-hor-2-module";
import { DrawDvHor1Module } from "./dv-hor-1-module";
import { DrawVdHor1Module } from "./vd-hor-1-module";
import { DrawVdHor2Module } from "./vd-hor-2-module";
import { DrawSdvTri1Module } from "./sdv-tri-1-module";
import { DrawSdvTri2Module } from "./sdv-tri-2-module";

export class DrawTagsAndLabelsContainer extends DrawingModuleContainer {
	render() {
		return html`
			<style>
				.shapes>*[shape-base]{
					max-height: 90px;
					max-width: 90px;
				}
			</style>
			${super.render()}`;
	}

	constructor(canvas) {
		super(canvas);

		this.moduleId = "tagsAndLabels";
		this.icon = tagsLabels;
		this.label = "Tags + Labels";
		this.toolbarWidth = "300px";

		let items = [
			"A" //, 'B', 'C'
			//, 'D', 'E', 'F', 'G', 'H', 'I'
		];

		items.forEach(i => {
			this.submodules.push(
				new DrawTagsAndLabelsModule(canvas, "#00FF00", i, "verwijderd ca. m2")
			);
		});
		items.forEach(i => {
			this.submodules.push(
				new DrawTagsAndLabelsModule(canvas, "#FF0000", i, "blijft aanwezig")
			);
		});
		this.submodules.push(new SecondaryToolbarSeparator());
		this.submodules.push(new DrawSquaresModule(canvas, "lime"));
		this.submodules.push(new DrawSquaresModule(canvas, "red"));
		this.submodules.push(new DrawSamplePumpModule(this.canvas, "cyan", "red", "1"));
		this.submodules.push(new DrawSamplePumpModule(this.canvas, "lime", "red", "1"));
		this.submodules.push(new DrawSamplePumpModule(this.canvas, "magenta", "darkblue", "1"));
		this.submodules.push(new SecondaryToolbarSeparator());
		this.submodules.push(new DrawSdvHor1Module(canvas));
		this.submodules.push(new DrawSdvHor2Module(canvas));
		this.submodules.push(new DrawVdsHor1Module(canvas));
		this.submodules.push(new DrawVdsHor2Module(canvas));
		this.submodules.push(new DrawSdvTri1Module(canvas));
		this.submodules.push(new DrawSdvTri2Module(canvas));
		this.submodules.push(new DrawVdHor1Module(canvas));
		this.submodules.push(new DrawVdHor2Module(canvas));
		this.submodules.push(new DrawDvHor1Module(canvas));
		this.submodules.push(new DrawDvHor2Module(canvas));
		this.submodules.push(new DrawBobcatModule(canvas));
		this.submodules.push(new DrawKraanModule(canvas));
		this.submodules.push(new DrawAanhangerModule(canvas));
		this.submodules.push(new DrawVerreikerModule(canvas));
		this.submodules.push(new DrawHoogwerkerModule(canvas));
		this.submodules.push(new DrawPickupModule(canvas));
		this.submodules.push(new DrawDecoVer1Module(canvas));
		this.submodules.push(new DrawDecoVer2Module(canvas));
		this.submodules.push(new DrawDecoHor1Module(canvas));
		this.submodules.push(new DrawDecoHor2Module(canvas));

		this.submodules.push(new DrawSluisHor1Module(canvas));
		this.submodules.push(new DrawSluisHor2Module(canvas));
		this.submodules.push(new DrawSluisHor3Module(canvas));
		this.submodules.push(new DrawSluisHor4Module(canvas));
		this.submodules.push(new DrawSluisVer1Module(canvas));
		this.submodules.push(new DrawSluisVer2Module(canvas));
		this.submodules.push(new DrawSluisVer3Module(canvas));
		this.submodules.push(new DrawSluisVer4Module(canvas));

		this.submodules.push(new DrawOdmModule(canvas));
		this.submodules.push(new DrawKeukenblokMagentaModule(canvas));
		this.submodules.push(new DrawKeukenblokGreenModule(canvas));
		this.submodules.push(new DrawKeukenblokRedModule(canvas));
		this.submodules.push(new DrawCvBlueModule(canvas));
		this.submodules.push(new DrawCvWhiteModule(canvas));
		this.submodules.push(new DrawRadiatorGreenModule(canvas));
		this.submodules.push(new DrawRadiatorWhiteModule(canvas));
		this.submodules.push(new DrawRadiatorBlueModule(canvas));
		this.submodules.push(new DrawContainerModule(canvas));
		this.submodules.push(new DrawBigBagModule(canvas));
		this.submodules.push(new DrawPuinModule(canvas));
		this.submodules.push(new DrawBoomModule(canvas));
		this.submodules.push(new DrawBegroeiingModule(canvas));
		this.submodules.push(new DrawBlueModule(canvas));
	}
}

window.customElements.define("inspx-draw-tags-lables-container", DrawTagsAndLabelsContainer);
